import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=29e7021a&"
import script from "./HowItWorks.js?vue&type=script&lang=js&"
export * from "./HowItWorks.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports